import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Invoice from './icon-invoice.svg';

type Props = {
    fill?: string;
    color?: string; // Add new cards pass color prop
};
function SvgComponent(props: Props) {
    const iconColor = props.color || props.fill || 'white';
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <Invoice {...validProps} color={iconColor} />;
}
SvgComponent.iconName = 'invoice';

export const InvoiceIcon = svgIconWrapper(SvgComponent);
